import NavLayout from './NavLayout';
import {SeoLayout, SeoIntrup} from './SeoLayout';
import ResponsiveLayout from './ResponsiveLayout';
import JobFeed from './Body/Jobfeed';
import RegistrationLayout from './Body/Registration';

export {
  NavLayout,
  SeoLayout,
  SeoIntrup,
  ResponsiveLayout,
  JobFeed,
  RegistrationLayout,
};
